module.exports = __webpack_public_path__ + "ddc05dff795b5f6c4de8dcc51dd375fc.pdf";